import type { FC } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import classnames from 'classnames';
import { PapiUser } from '@wix/da-papi-types';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import { pushModal, popModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';

import { pushBadgeModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import s from './AvatarBirthdayBadge.scss';

export interface Props {
  isOwner: boolean;
  profileOwnerUser: PapiUser;
}

const AvatarBirthdayBadge: FC<Props> = ({ isOwner, profileOwnerUser }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const assetUrl = 'https://st.deviantart.net/badges/cake/huge/19-sparklerific-cake.gif';
  const confirmationImageUrl = 'https://st.deviantart.net/eclipse/popups/give-popups/cake.png';

  const handleCakeClick = useCallback(() => {
    if (isOwner) {
      return;
    }

    dispatch(
      pushModal(ModalType.CONFIRMATION, {
        params: {
          title: t('widgets.profile.birthdayWeek.giveCake.title'),
          text: t('widgets.profile.birthdayWeek.giveCake.message', {
            username: profileOwnerUser.username,
          }),
          icon: <img src={confirmationImageUrl} alt="" width={119} height={119} />,
          confirmBtnLabel: t('widgets.profile.birthdayWeek.giveCake.confirm'),
          cancelBtnLabel: t('widgets.profile.birthdayWeek.giveCake.cancel'),
          onConfirm: () => {
            // Use setTimeout to ensure confirmation modal closes first
            setTimeout(() => {
              dispatch(
                pushBadgeModal(
                  profileOwnerUser.username,
                  () => {},
                  () => dispatch(popModal()),
                  'cake'
                )
              );
            }, 100);
          },
        },
      })
    );
  }, [isOwner, dispatch, t, profileOwnerUser.username, confirmationImageUrl]);

  const tooltipText = isOwner
    ? t('widgets.profile.birthdayWeek.owner')
    : t('widgets.profile.birthdayWeek.visitor', {
        username: profileOwnerUser.username,
      });

  return (
    <div className={s['root']}>
      <SimpleTooltip placement="bottom" usePortal text={tooltipText}>
        <img
          className={classnames(s['cake'], !isOwner && s['clickable'])}
          alt={t('widgets.profile.birthdayWeek.visitor', {
            username: profileOwnerUser.username,
          })}
          src={assetUrl}
          onClick={handleCakeClick}
        />
      </SimpleTooltip>
    </div>
  );
};
AvatarBirthdayBadge.displayName = 'AvatarBirthdayBadge';
export default AvatarBirthdayBadge;
